// candidate.service.ts

import { IUserRoleFormInput } from "../../Pages/UserRole/UserRole.model";
import { buildApiUrl } from "../../config/api";
import axiosInstance from "../axios/axiosInstance";

const API = buildApiUrl("/usersApp/user_roles/");

export const userRoleService = {
  async getAll() {
    return axiosInstance.get(API);
  },
  async create(payload: IUserRoleFormInput) {
    return axiosInstance.post(API, payload);
  },
  async update(id: number, data: IUserRoleFormInput) {
    try {
      const res = await axiosInstance.put(`${API}${id}/`, data);
      return { success: true, data: res.data };
    } catch (err: any) {
      return {
        success: false,
        errors: err.response?.data || {},
      };
    }
  },
  async updatePermissions(data: { role_id: number; permission_ids: number[] }) {
    try {
      const res = await axiosInstance.patch(`${API}update-permissions/`, data);
      return { success: true, data: res.data };
    } catch (err: any) {
      return {
        success: false,
        errors: err.response?.data || {},
      };
    }
  },

  async remove(id: number) {
    try {
      const res = await axiosInstance.delete(`${API}${id}/`);
      return { success: true, data: res };
    } catch (err: any) {
      return {
        success: false,
        errors: err.response?.data || {},
      };
    }
  },
};
